import { createFileRoute } from '@tanstack/react-router'

import { TabletLayout } from '@/widgets/tablet/tablet-layout'

export const Route = createFileRoute('/_tablet-layout')({
    component: TabletLayout,
    onEnter: () => {
        document.title = 'Катит'
    },
})
